import { GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP as methodology } from "../ghg-administration";
const facilities = methodology.sectors.MUNICIPAL_FACILITIES;
export const GHG_ADMINISTRATION_BUILDING_SUBSECTOR_LIST = [
    facilities.subsectors.SCHOOLS_DAYCARE,
    facilities.subsectors.ADMINISTRATIVE_BUILDINGS,
    facilities.subsectors.OTHER_MUNICIPAL_BUILDINGS,
];
export const GHG_ADMINISTRATION_BUILDING_SUBSECTOR_ID_LIST = GHG_ADMINISTRATION_BUILDING_SUBSECTOR_LIST.map((subsector) => subsector.id);
